import { useSearchParams } from 'react-router-dom';
import { FilterOption } from './GenericFilterMultiSelect';
import { ListFilterOption } from '@common/ui/ListFilters/common';
import { useState } from 'react';
import ListFilter from '@common/ui/ListFilters/ListFilter';
import ListFilterSelectChipTrigger from '@common/ui/ListFilters/ListFilterSelectChipTrigger';
import ListFilterSingleSelect from '@common/ui/ListFilters/ListFilterSingleSelect';
import { AnalyticsTriggerElementProps } from '@common/types';

export interface FilterProps {
  options: FilterOption[];
  opened?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  filterParam: string;
  filterLabel: string;
  isLoading: boolean;
  handleSelect?: (value: ListFilterOption) => void;
  handleClear?: () => void;
}

export default function GenericFilterSingleSelect({
  options,
  opened = false,
  onClose,
  onOpen,
  filterLabel,
  filterParam,
  isLoading,
  handleSelect,
  handleClear,
  ...analyticsProps
}: FilterProps & AnalyticsTriggerElementProps) {
  const [isOpen, setIsOpen] = useState(opened);
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedQp = searchParams.get(filterParam) || undefined;

  const selectedOption = options.find((option) => option.value === selectedQp) || undefined;

  const handleOnSelect = (value: ListFilterOption) => {
    if (handleSelect) {
      handleSelect(value);
    } else {
      searchParams.set(filterParam, value.value);
      setSearchParams(searchParams);
    }
  };

  const handleOnClear = () => {
    if (handleClear) {
      handleClear();
    } else {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(filterParam);
      setSearchParams(newSearchParams);
    }
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <ListFilter
      trigger={
        <ListFilterSelectChipTrigger
          active={isOpen}
          label={filterLabel}
          value={selectedOption ? [selectedOption] : []}
          onClear={handleOnClear}
          loading={isLoading}
          enableClear={true}
        />
      }
      popoverProps={{
        isOpen,
        toggleDropdown,
        closeDropdown,
      }}
      width={300}
    >
      <ListFilterSingleSelect
        options={options}
        value={selectedOption}
        onSelect={handleOnSelect}
        title="Select Access Scope"
        isFetching={isLoading}
        enableSearch
        {...analyticsProps}
      />
    </ListFilter>
  );
}
